// 常用函数集
export const macddCompare = ddver => {
  const list = ddver.split(".");
  const dlist = "4.7.10".split(".");
  for (let i = 0; i < list.length; i++) {
    if (+list[i] > +dlist[i]) {
      return true;
    }
    if (+list[i] < +dlist[i]) {
      return false;
    }
  }
  if (ddver == "4.7.10") {
    return true;
  }
  // 版本 不符合
  return false;
};
export const ddCompare = ddver => {
  try {
    const ve = ddver.split("-")[0];
    const vr = ddver.split(/\.(?=[^.]*$)/)[1];

    const list = ve.split(".");
    const dlist = "4.7.9".split(".");

    for (let i = 0; i < list.length; i++) {
      //console.log(Number(list[i]), Number(dlist[i]));
      if (Number(list[i]) > Number(dlist[i])) {
        return true;
      }
      if (Number(list[i]) < Number(dlist[i])) {
        return false;
      }
    }

    if (ve == "4.7.9") {
      //大于等于此版本
      if (Number(vr) >= Number("202")) {
        return true;
      }
    }

    // 版本 不符合
    return false;
  } catch (e) {
    return true;
  }
};

export const macddCompareNew = ddver => {
  const list = ddver.split(".");
  const dlist = "4.7.11".split(".");
  for (let i = 0; i < list.length; i++) {
    if (+list[i] > +dlist[i]) {
      return true;
    }
    if (+list[i] < +dlist[i]) {
      return false;
    }
  }
  if (ddver == "4.7.11") {
    return true;
  }
  // 版本 不符合
  return false;
};
export const ddCompareNew = ddver => {
  try {
    const ve = ddver.split("-")[0];
    const vr = ddver.split(/\.(?=[^.]*$)/)[1];

    const list = ve.split(".");
    const dlist = "4.7.10".split(".");

    for (let i = 0; i < list.length; i++) {
      //console.log(Number(list[i]), Number(dlist[i]));
      if (Number(list[i]) > Number(dlist[i])) {
        return true;
      }
      if (Number(list[i]) < Number(dlist[i])) {
        return false;
      }
    }

    if (ve == "4.7.10") {
      //大于等于此版本
      if (Number(vr) >= Number("39")) {
        return true;
      }
    }

    // 版本 不符合
    return false;
  } catch (e) {
    return true;
  }
};

export const OSnow = () => {
  var agent = navigator.userAgent.toLowerCase();
  var isMac = /macintosh|mac os x/i.test(navigator.userAgent);
  if (agent.indexOf("win32") >= 0 || agent.indexOf("wow32") >= 0) {
    return "win32";
  }
  if (agent.indexOf("win64") >= 0 || agent.indexOf("wow64") >= 0) {
    return "win64";
  }
  if (isMac) {
    return "mac";
  }
};

// js json转url参数
export const jsonToUrl = json => {
  return Object.keys(json)
    .map(function(key) {
      return encodeURIComponent(key) + "=" + encodeURIComponent(json[key]);
    })
    .join("&");
};

// 相对于指定父级的偏移
export const getLeft = (e, o) => {
  if (!e) return;
  var offset = e.offsetLeft;
  if (e.parentNode.tagName == "BODY") {
    return offset;
  }

  if (e.parentNode.tagName != "BODY" || e.parentNode.className != o)
    offset += getLeft(e.parentNode, o);
  return offset;
};

// 相对于窗口 的偏移
export const getBoundLeft = e => {
  if (!e) return;
  return e.getBoundingClientRect().left;
};

// 是否pc电脑
function ispcFunc() {
  if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
    return false; //移动端
  }
  if (/(Android)/i.test(navigator.userAgent)) {
    return false; //移动端
  }
  return true; //pc
}
export const ispc = ispcFunc();
